import PropTypes from 'prop-types';
// -*- mode: jsx;-*-
import { Svg } from './Svg.js';
import { KeyboardClickable } from './KeyboardClickable.js';
import { SHARE_TOOLS, trackShareToolClick } from './shareToolUtils.js';

/* global dcAnalytics */


export const EmailLink = function (props) {
    function onEmailClick(event) {
        event.preventDefault();
        props.getTafEmail(props.pageName, event.currentTarget, getUrl());
        trackShareToolClick(props.projectId, SHARE_TOOLS.EMAIL);
        dcAnalytics.trackShareToolClick(props.pageName, props.tafURL, 'TellAFriend', props.essentialsListShare);
        props.onEmailClick(event);
    }

    function getUrl() {
        return props.tafURL + (props.secure ? '&secure=true' : '');
    }

    const url = getUrl();

    if (props.useSpan) {
        return (
            <KeyboardClickable>
                {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions,jsx-a11y/no-noninteractive-tabindex */}
                <a className={props.className + ' button-secondary small heap-email-share'}
                   aria-label='Share via email' title='Email to friends' tabIndex='0'
                   data-title='Email to friends' href={url} onClick={onEmailClick}>
                    <Svg icon='ss-mail' iconFamily='social-circle'/>
                    {props.children}
                </a>
            </KeyboardClickable>
        );
    } else {
        return (
            <a className={props.className + ' button-secondary small heap-email-share'}
               aria-label='Share via email' title='Email to friends' tabIndex='0'
               data-title='Email to friends' href={url} onClick={onEmailClick}>
                <Svg icon='ss-mail' iconFamily='social-circle'/>
                {props.children}
            </a>
        );
    }
};

EmailLink.propTypes = {
    secure: PropTypes.bool.isRequired,
    tafURL: PropTypes.string.isRequired,
    pageName: PropTypes.string.isRequired,
    projectId: PropTypes.number,

    getTafEmail: PropTypes.func.isRequired,
    onEmailClick: PropTypes.func.isRequired,

    useSpan: PropTypes.bool,
    className: PropTypes.string,
    children: PropTypes.element,
    essentialsListShare: PropTypes.bool,
};
